import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

/** Maximise button for mini cards — opens the full-sized card in a modal. */
export const MiniCardExpand: React.FC<{ label: string; fullCard: React.ReactNode }> = ({ label, fullCard }) => {
  const [open, setOpen] = React.useState(false);
  return <>
    <IconButton
      size="small"
      onClick={(event) => { event.stopPropagation(); setOpen(true); }}
      aria-label={`View full card for ${label}`}
      sx={{ flexShrink: 0 }}
    >
      <OpenInFullIcon fontSize="inherit" />
    </IconButton>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 1 }}>
        {fullCard}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  </>;
};
